import type { HospitolSetupStatus } from "./hospitol-setup-store";

export function isHospitolSetupComplete(status: HospitolSetupStatus | null | undefined): boolean {
  return status?.complete === true;
}

export interface SetupStatusMessage {
  variant: "info" | "warning";
  title: string;
  detail: string;
  ctaStep?: number;
}

const CHECK_LABELS: Record<keyof HospitolSetupStatus["checks"], string> = {
  establishment: "profil établissement",
  medicalUnits: "services médicaux",
  surgeryUnit: "unité chirurgie / bloc",
  reception: "tarifs accueil",
  hospitalRevenue: "tarifs revenus hospitaliers",
  pharmacy: "paramètres pharmacie",
  insurance: "partenariat assureur",
};

export function buildHospitolSetupStatusMessage(
  status: HospitolSetupStatus,
): SetupStatusMessage | null {
  if (isHospitolSetupComplete(status)) return null;

  const missing = (Object.entries(status.checks) as [keyof HospitolSetupStatus["checks"], boolean][])
    .filter(([, ok]) => !ok)
    .map(([key]) => CHECK_LABELS[key]);

  const detail =
    missing.length > 0
      ? `Éléments à compléter : ${missing.join(", ")}.`
      : "Finalisez l'assistant pour activer complètement votre établissement.";

  return {
    variant: status.progressPercent >= 60 ? "info" : "warning",
    title: "Mise en route en cours",
    detail,
    ctaStep: status.currentStep || 1,
  };
}
